<template>
  <div class="jps-show-more" :id="item.key">
    <div class="edit" v-if="editstate">
      <span>{{
        item.def.title
          ? ls(item.def.title)
          : ls(typeLabel) + lss('検索結果', 'Search Result')
      }}</span>
      <div>
        <button

          type="button"
          class="jps-round-button"
          @click="setSearchQuery()"
        >
          {{ lss('検索条件の設定', 'Set search condtions') }}
        </button>
        <SetSearchResultModal ref="setSearchResultModal" />
      </div>
    </div>
    <template v-else>
      <div
        v-if="
          item.searchStatus === 'waiting' || item.searchStatus === 'searching'
        "
        :class="{'hina-logo-icon hina-loading': isHina, 'jps-logo-icon jps-loading': isJps}"
      />
      <button
        v-else
        type="button"
        class="jps-round-button"
        @click="item.readNext()"
      >
        {{ ls(dapLangGlobal.more) }}
      </button>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
import type { SetSearchResultModal } from '#components'

const { isJps, isHina } = useServiceType()
const { ls, lss } = useI18n()

interface Props {
  item: ListElement
  editstate?: CurationEditState
}
const props = withDefaults(defineProps<Props>(), {})

const typeLabel = computed(() => {
  if (props.item.def.dataType === 'item') {
    return { ja: 'メタデータ', en: 'Metadata' }
  } else if (props.item.def.dataType === 'curation') {
    return { ja: 'ギャラリー', en: 'Gallery' }
  }
  return {}
})

const setSearchResultModal = ref<InstanceType<typeof SetSearchResultModal>>()
const setSearchQuery = async () => {
  try {
    const clonedDef = clone(props.item.def)
    const plsr: PartListSearchResult = await setSearchResultModal.value.openAwait({ def: clonedDef })
    if (!plsr) return
    props.item.def.query = plsr.query
    props.item.def.csId = plsr.csId
  } catch (cancel) {}
}
</script>

<style lang="scss" scoped>
.jps-show-more {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  .edit {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
}
</style>
